<template>
  <div class="home">
    <LoginWidget/>
  </div>
</template>

<script setup>
import LoginWidget from "@/components/LoginWidget.vue";
</script>

<style lang="scss">
.home {
  display: flex;
  height: 100vh;
  width: 100vw;
  justify-content: center;
  align-items: center;
}
</style>
